var exports = {
  "kL": "GuildNotificationSettingsModal.module__container___LVd2Mm",
  "uW": "GuildNotificationSettingsModal.module__section___LVd2Mm",
  "Gf": "GuildNotificationSettingsModal.module__sectionTitle___LVd2Mm",
  "yV": "GuildNotificationSettingsModal.module__sectionDescription___LVd2Mm",
  "nv": "GuildNotificationSettingsModal.module__notificationSection___LVd2Mm",
  "RG": "GuildNotificationSettingsModal.module__suppressSection___LVd2Mm",
  "Sj": "GuildNotificationSettingsModal.module__mobilePushSection___LVd2Mm",
  "dY": "GuildNotificationSettingsModal.module__overridesSection___LVd2Mm",
  "dr": "GuildNotificationSettingsModal.module__overridesHeader___LVd2Mm",
  "bY": "GuildNotificationSettingsModal.module__overridesHeaderCell___LVd2Mm",
  "u1": "GuildNotificationSettingsModal.module__overridesHeaderCellLeft___LVd2Mm",
  "c": "GuildNotificationSettingsModal.module__overridesHeaderCellMute___LVd2Mm",
  "IC": "GuildNotificationSettingsModal.module__overrideItem___LVd2Mm",
  "sr": "GuildNotificationSettingsModal.module__overrideHeader___LVd2Mm",
  "yW": "GuildNotificationSettingsModal.module__channelInfo___LVd2Mm",
  "p": "GuildNotificationSettingsModal.module__channelIcon___LVd2Mm",
  "E8": "GuildNotificationSettingsModal.module__channelDetails___LVd2Mm",
  "HA": "GuildNotificationSettingsModal.module__channelName___LVd2Mm",
  "yb": "GuildNotificationSettingsModal.module__categoryName___LVd2Mm",
  "Z5": "GuildNotificationSettingsModal.module__mobileOverrideOptions___LVd2Mm",
  "Ue": "GuildNotificationSettingsModal.module__desktopNotificationOptions___LVd2Mm",
  "of": "GuildNotificationSettingsModal.module__checkboxCell___LVd2Mm",
  "DT": "GuildNotificationSettingsModal.module__removeButton___LVd2Mm",
  "kI": "GuildNotificationSettingsModal.module__iconTertiary___LVd2Mm",
};

module.exports = exports;
